var React = require('react');
var Col = require('react-bootstrap').Col;
var Link = require('react-router').Link;
var Row = require('react-bootstrap').Row;
import PageHeader from '../Layout/PageHeader';

import DomainHint from '../Domain/DomainHint.js';
var UserStore = require('../../stores/UserStore');
var ClientServiceTable = require('../ClientService/Table');
var SummaryTable = require('../Invoice/SummaryTable');
var Outdated = require('../ClientService/Outdated');

var Dashboard = React.createClass({
    render: function () {
        return <section id="dashboard">
            <PageHeader><h1>Customer Portal</h1></PageHeader>

            <Row>
                <Col lg={8}>
                    <Outdated />

                    <ClientServiceTable widgetName="Service Summary" showIpAddress={false} hideSingleBillingGroup={true} showSite={false}>
                        <div className="callout callout-info">
                            <p>
                                This list contains all active services on your account
                                broken down by their billing groups.
                            </p>
                            <p>
                                For more information on what a billing group is and will
                                let you achieve on your account see <Link to="accounting">here</Link>.<br />
                            </p>
                            <p>
                                To make changes to billing groups please contact us using
                                the <Link to="support">support page</Link>.
                            </p>
                        </div>

                        <DomainHint>
                            <div className="callout callout-info">
                                <p>Do you have any domains registered with Infinite Networks? Log into our <a href="https://infinite.partnerconsole.net/" target="_blank">domains portal</a> to review your domains and update your credit card information.</p>
                            </div>
                        </DomainHint>
                    </ClientServiceTable>
                </Col>
                <Col lg={4}>
                  {UserStore.hasRole(['ACCOUNTING', 'ADMIN', 'OWNER']) && (
                    <section className="powerwidget purple">
                        <header><h2>Recent Invoices</h2></header>
                        <div className="inner-spacer">
                          {this.props.children}
                            <div className="table-responsive">
                                <SummaryTable />
                            </div>

                            <div style={{ textAlign: 'right' }}>
                                <Link to="accounting">View More</Link>
                            </div>
                        </div>
                    </section>
                  )}
                </Col>
            </Row>
        </section>;
    }
})
module.exports = Dashboard;



// WEBPACK FOOTER //
// ./app/components/Dashboard/Dashboard.js